module.exports = __webpack_public_path__ + "media/images/flags/kr-b8c4a87f19e4ec1d2f5b0f9daede1cdf.svg";